export const LANGUAGE = 'LANGUAGE';
